import type { PublicFileData } from '@mogul/api-client';
import React from 'react';

import styles from './PromoVideo.module.css';

interface VideoProps {
  videoUrl: PublicFileData | null;
}
export const PromoVideo: React.FC<VideoProps> = ({ videoUrl }) => {
  let publicUrl = videoUrl?.publicUrl ?? '';
  publicUrl = publicUrl.replace('d8r7g9tzupsfa', 'd2bhvhyqzg9zio');

  return (
    <div className={`sm:mx-0 mx-10 pb-5`}>
      <h1 className={`${styles.videoTextHeader} pb-1`}>Promo</h1>
      <video
        controls
        autoPlay={true}
        muted
        playsInline
        src={publicUrl}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};
